import { useState } from "react";
import { api } from "../api.ts";
import { dashMacUrl, openDashMac } from "../utils/dashLinks.ts";

export function Device360({ mac }: { mac: string }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<Record<string, unknown> | null>(null);
  const [err, setErr] = useState("");

  const toggle = () => {
    const n = !open;
    setOpen(n);
    if (n && !data) {
      api<Record<string, unknown>>(`/support/devices/${encodeURIComponent(mac)}/360`)
        .then((d) => { setData(d); setErr(""); })
        .catch((e) => setErr(e instanceof Error ? e.message : String(e)));
    }
  };

  const dev = (data?.device as Record<string, unknown>) || null;
  const alerts = (data?.recent_alerts as Array<Record<string, unknown>>) || [];
  const tks = (data?.tickets as Array<Record<string, unknown>>) || [];
  const parts = (data?.parts_consumed as Array<Record<string, unknown>>) || [];

  return (
    <div className="support-collapse">
      <button type="button" className="support-collapse__trigger" onClick={toggle}>
        <span className="support-collapse__chevron" aria-hidden>{open ? "▼" : "▶"}</span>
        <span className="support-collapse__title">機体360</span>
        {!open ? (
          <span className="support-collapse__summary">
            <a
              href={dashMacUrl(mac)}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              style={{ fontFamily: "'JetBrains Mono',monospace", color: "var(--primary,#358b39)" }}
            >
              {mac}
            </a>
          </span>
        ) : null}
      </button>
      {open && (
        <div className="support-collapse__body" style={{ fontSize: "0.8rem", lineHeight: 1.7 }}>
          <div style={{ marginBottom: "0.35rem" }}>
            <button
              type="button"
              onClick={() => openDashMac(mac)}
              style={{
                padding: "0.25rem 0.55rem",
                borderRadius: 6,
                border: "1px solid var(--primary,#358b39)",
                background: "transparent",
                color: "var(--primary,#358b39)",
                fontSize: "0.75rem",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              dash でテレメトリを見る →
            </button>
          </div>
          {err && <div style={{ color: "var(--danger,#e53935)" }}>{err}</div>}
          {dev ? (
            <div style={{ marginBottom: "0.4rem" }}>
              SoC: <b>{String(dev.last_soc ?? "—")}</b> / 電圧: <b>{String(dev.voltage ?? "—")}</b> / サイクル: <b>{String(dev.cycle_count ?? "—")}</b><br />
              直近アラート: {String(dev.last_alert_type ?? "—")} / 最終通信: {dev.last_seen ? new Date(String(dev.last_seen)).toLocaleString() : "—"}<br />
              設置: {String(dev.location ?? "—")} / FW: {String(dev.lcdfw_version ?? "—")}
            </div>
          ) : <div style={{ color: "var(--text-secondary,#5f635f)" }}>{data ? "デバイス台帳に未登録" : "読み込み中…"}</div>}
          <div><b>未解決アラート:</b> {String(data?.open_alert_count ?? 0)} 件</div>
          {alerts.length > 0 && (
            <div style={{ margin: "0.2rem 0" }}>
              <b>アラート履歴:</b>
              {alerts.slice(0, 5).map((a, i) => (
                <div key={i} style={{ fontSize: "0.72rem", color: "var(--text-secondary,#5f635f)" }}>
                  ・[{String(a.alert_level)}] {String(a.alert_type)} {a.timestamp ? new Date(String(a.timestamp)).toLocaleDateString() : ""}
                </div>
              ))}
            </div>
          )}
          <div><b>この機体の過去チケット:</b> {tks.length} 件</div>
          {tks.slice(0, 5).map((t, i) => (
            <div key={i} style={{ fontSize: "0.72rem", color: "var(--text-secondary,#5f635f)" }}>
              ・{String(t.ticket_number)} [{String(t.status)}] {String(t.title || "").slice(0, 30)}{t.csat_score ? ` ⭐${t.csat_score}` : ""}
            </div>
          ))}
          {parts.length > 0 && <div><b>交換部品:</b> {parts.map((p) => `${p.label || p.part_code}×${p.qty}`).join(" / ")}</div>}
        </div>
      )}
    </div>
  );
}
